export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7facc75e8f5ee53e2863403c126fadd03d5f427174&name=fetchTypeahead!'